import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { NotDiagnosis } from './components/NotDiagnosis';
import { PainPoints } from './components/PainPoints';
import { ProductIntro } from './components/ProductIntro';
import { ProblemReal } from './components/ProblemReal';
import { WhyFails } from './components/WhyFails';
import { SistemaRuta } from './components/SistemaRuta';
import { Deliverables } from './components/Deliverables';
import { ForWho } from './components/ForWho';
import { PriceSection } from './components/PriceSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
function loadMetaPixel(pixelId: string) {
  if (window.fbq) return;
  const n = window.fbq = function (...args: unknown[]) {
    if ((n as any).callMethod) {
      ;
      (n as any).callMethod.apply(n, args);
    } else {
      ;
      (n as any).queue.push(args);
    }
  } as any;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as unknown[][];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    loadMetaPixel('877859571789557');
  }, []);
  return <div className="font-sans text-[#1B2A4A] bg-white min-h-screen selection:bg-[#3BBFAD]/20" data-id="element-0">
      <style data-id="element-1">{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap');
        
        html {
          scroll-behavior: smooth;
        }
      `}</style>

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <NotDiagnosis data-id="element-4" />
        <PainPoints data-id="element-5" />
        <ProductIntro data-id="element-6" />
        <ProblemReal data-id="element-7" />
        <WhyFails data-id="element-8" />
        <SistemaRuta data-id="element-9" />
        <Deliverables data-id="element-10" />
        <ForWho data-id="element-11" />
        <PriceSection data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}